import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const getIconStyle = (size, style) => (size ? { ...style, fontSize: size, width: size, height: size } : style);

const BillingInvoicesTabIcon = ({ size, style, ...props }) => (
    <SvgIcon viewBox='21.5 20.8 15.8 15.9' style={getIconStyle(size, style)} {...props}>
        <path
            fill='currentColor'
            d='M32.1,35.2c-1.7,0-3.2-1.4-3.2-3.1s1.4-3.2,3.2-3.2,3.1,1.4,3.1,3.2-1.4,3.1-3.1,3.1M28.6,32.4h-.6v-4.8h1.6v2c-.6.6-1,1.5-1,2.5,0,.1,0,.2,0,.3ZM27.6,27.2h-1.7v-1.3h1.7v1.3ZM27.6,32.4h-1.7v-4.8h1.7v4.8ZM25.5,27.2h-1.6v-1.3h1.6v1.3ZM25.5,32.4h-1.6v-4.8h1.6v4.8ZM28,25.9h1.6v1.3h-1.6v-1.3ZM29,21.4l1.9,1.9h-1.4c-.3,0-.5-.2-.5-.5v-1.4ZM32.1,28.6c-.8,0-1.5.3-2.1.7v-1.9s0,0,0,0v-1.7c0,0,0-.2-.2-.2h-6c0,0-.2,0-.2.2v1.7s0,0,0,0v5.2c0,0,0,.2.2.2h4.9c0,.4.2.8.4,1.1h-6.1c-.4,0-.6-.3-.6-.6v-11.4c0-.4.3-.6.6-.6h5.6s0,1.6,0,1.6c0,.5.4.9.9.9h1.6v4.3c0,0,0,.2.2.2s.2,0,.2-.2v-4.5s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h-.1c-.8-1-1.4-1.5-2.2-2.4h-.1c0-.1,0-.1,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h-5.8c-.6,0-1,.4-1,1v11.4c0,.6.4,1,1,1h6.3c.6.8,1.6,1.3,2.8,1.3,1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5Z'
        />
    </SvgIcon>
);

export default BillingInvoicesTabIcon;